import React from 'react';
import Switch from "react-switch";

const Toggle = ({ checked, onChange }) => (

    <Switch 
    checkedIcon={false}
    uncheckedIcon={false}
    height={25}
    width={50}
    onChange={onChange} 
    checked={checked} />    
   
);

export default Toggle;